import CardActionButtonList from '../action-formatters/CardActionButtonList';
import { useMemo } from 'react';
import ActionErrorTag from '../action-formatters/ActionErrorTag';
import { TITLE_SELECTOR, ACTIONS_SELECTOR } from '../constants/CardSeleniumSelectors';
import { CARD_FORMATTER_IFRAME_LOOKUP_KEYS } from '../constants/IframeLookupKeys';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function GridCardFormatter({
  actionComponent,
  actionConfigs,
  cardType,
  children,
  hasActionsLoadingError,
  legacyDataAttributes: {
    ['data-sidebar-card-type']: legacyDataSidebarCardType,
    ['data-sidebar-card-association-object-type-id']: legacyDataSidebarCardAssociationObjectTypeId,
    ['data-sidebar-key']: legacyDataSidebarKey
  } = {},
  title,
  ActionFormatter = CardActionButtonList
}) {
  const toolbar = useMemo(() => {
    if (hasActionsLoadingError) {
      return /*#__PURE__*/_jsx(ActionErrorTag, {});
    }
    if (actionComponent) {
      return actionComponent;
    }
    if (actionConfigs) {
      return /*#__PURE__*/_jsx(ActionFormatter, {
        actionConfigs: actionConfigs
      });
    }
    return undefined;
  }, [hasActionsLoadingError, actionConfigs, actionComponent, ActionFormatter]);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    "data-sidebar-card-type": legacyDataSidebarCardType,
    "data-sidebar-card-association-object-type-id": legacyDataSidebarCardAssociationObjectTypeId,
    "data-sidebar-key": legacyDataSidebarKey,
    "data-card-type": cardType,
    compact: true,
    blockSize: "auto",
    marginBlockEnd: "0",
    children: [(title || toolbar) && /*#__PURE__*/_jsx(CardHeader, {
      title: title && /*#__PURE__*/_jsx("span", {
        "data-selenium-test": TITLE_SELECTOR,
        children: title
      }),
      titleSize: "small",
      toolbar: toolbar && /*#__PURE__*/_jsx("span", {
        "data-selenium-test": ACTIONS_SELECTOR,
        children: toolbar
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      children: children
    })]
  });
}
GridCardFormatter.iframeLookupKey = CARD_FORMATTER_IFRAME_LOOKUP_KEYS.GRID_CARD_FORMATTER;